import React from 'react';
import { useHistory } from 'react-router-dom';
import { withAlert } from 'react-alert';
import { observer } from 'mobx-react-lite';
import { ROLES } from '../../helpers/role-config';
import Logo from '../../assets/images/FoodCourt.png';
import { Login as NewLogin } from '@cokitchen/cokitchen-auth';
import { LoginEnvType, LoginResponse } from '@cokitchen/cokitchen-auth/dist/lib/login/types';
import { AllowedRoleType } from '../../helpers/types';

const authEnvironment = process.env.REACT_APP_AUTH_ENVIRONMENT as LoginEnvType;

const Login = observer(function Login({ alert }: { alert: any }) {
  const history = useHistory();

  const handleLoginSuccess = (res: LoginResponse) => {
    const role = res.data.role as AllowedRoleType;
    if (Object.keys(ROLES).includes(role)) {
      const roleConfig = ROLES[role];
      history.push(roleConfig.baseRoute);
    } else {
      alert.show('Unrecognized login role!', {
        type: 'info'
      });
      localStorage.clear();
    }
  };
  return (
    <div className='auth-login__main min-h-screen bg-white px-0 md:px-16 pt-10'>
      <div className='flex justify-center bg-white text-center'>
        <img src={Logo} className='login__logo' alt='Food Court' />
      </div>

      <main className='auth-login__card'>
        <NewLogin onLogin={handleLoginSuccess} env={authEnvironment} />
      </main>
    </div>
  );
});
export default withAlert()(Login);
